import { useState } from "react";

const PASSWORD = process.env.REACT_APP_PREVIEW_PASSWORD;
const SESSION_KEY = "gt_preview_unlocked";

function isUnlocked() {
  try {
    return sessionStorage.getItem(SESSION_KEY) === "1";
  } catch {
    return false;
  }
}

export function PasswordGate({ children }) {
  const [unlocked, setUnlocked] = useState(isUnlocked);
  const [input, setInput] = useState("");
  const [error, setError] = useState(false);

  if (!PASSWORD || unlocked) return children;

  function handleSubmit(e) {
    e.preventDefault();
    if (input === PASSWORD) {
      try {
        sessionStorage.setItem(SESSION_KEY, "1");
      } catch {}
      setUnlocked(true);
    } else {
      setError(true);
      setInput("");
    }
  }

  return (
    <div style={styles.backdrop}>
      <div style={styles.card}>
        <div style={styles.logo}>gt<span style={styles.slash}>/</span>h</div>
        <p style={styles.label}>This preview is password protected.</p>
        <form onSubmit={handleSubmit} style={styles.form} noValidate>
          <input
            type="password"
            autoFocus
            autoComplete="current-password"
            placeholder="Password"
            value={input}
            onChange={(e) => { setInput(e.target.value); setError(false); }}
            style={{ ...styles.input, ...(error ? styles.inputError : {}) }}
            aria-label="Preview password"
            aria-invalid={error ? "true" : "false"}
            aria-describedby={error ? "gate-error" : undefined}
          />
          {error && (
            <p id="gate-error" style={styles.errorText} role="alert">
              Incorrect password.
            </p>
          )}
          <button type="submit" style={styles.button}>Enter</button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  backdrop: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "var(--bg)",
    fontFamily: "var(--font-body)",
  },
  card: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "1.25rem",
    padding: "2.5rem 2rem",
    background: "var(--surface)",
    border: "1px solid var(--border)",
    borderRadius: "16px",
    boxShadow: "0 30px 60px -20px rgba(0,0,0,0.7)",
    width: "100%",
    maxWidth: "360px",
  },
  logo: {
    fontSize: "1.25rem",
    fontWeight: 700,
    letterSpacing: "-0.02em",
    color: "var(--text)",
  },
  slash: {
    color: "var(--accent)",
  },
  label: {
    margin: 0,
    fontSize: "0.875rem",
    color: "var(--text-muted)",
    textAlign: "center",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "0.75rem",
    width: "100%",
  },
  input: {
    width: "100%",
    padding: "0.625rem 0.875rem",
    fontSize: "0.9375rem",
    border: "1px solid var(--border)",
    borderRadius: "10px",
    outline: "none",
    background: "var(--surface-raised)",
    color: "var(--text)",
    boxSizing: "border-box",
    transition: "border-color 0.15s",
  },
  inputError: {
    borderColor: "#ff6b6b",
  },
  errorText: {
    margin: 0,
    fontSize: "0.8125rem",
    color: "#ff6b6b",
  },
  button: {
    padding: "0.625rem",
    fontSize: "0.9375rem",
    fontWeight: 600,
    background: "var(--accent)",
    color: "#0b0d14",
    border: "none",
    borderRadius: "10px",
    cursor: "pointer",
    boxShadow: "0 0 24px rgba(95,216,240,0.25)",
  },
};
